/* eslint-disable no-undef */
import { ref, onMounted } from '@vue/composition-api'

export default function useVendorMap() {
  const locations = ref([])
  const mapOptions = {
    center: {
      lat: 31.963158, lng: 35.930359,
    },
    zoom: 10,
  }
  const initMarker = (e, map) => {
    let marker = null
    const { lat, lng } = e.latLng.toJSON()
    const myLatlng = new google.maps.LatLng(lat, lng)
    marker = new google.maps.Marker({
      position: myLatlng,
    })
    marker.setMap(map)
    locations.value.push({
      lat,
      lng,
      marker,
    })
    marker.addListener('click', () => {
      locations.value.splice(locations.value.indexOf(marker), 1)
      marker.setMap(null)
    })
  }

  const initMap = () => {
    const map = new google.maps.Map(document.getElementById('zoneMap'), mapOptions)
    map.addListener('click', e => {
      initMarker(e, map)
    })
  }

  onMounted(() => {
    initMap()
  })

  return {
    locations,
  }
}
